import React, { useState, useEffect } from "react";
import axios from "axios";
import { BaseURL } from "../../App";

const Dashboard = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${BaseURL}/user`);
        setUsers(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-3xl font-semibold mb-8 text-gray-800 pt-5 text-center">
        User List (Admin Panel)
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
          <thead className="bg-gray-200 text-gray-700">
            <tr>
              <th className="text-left py-3 px-4 uppercase font-semibold text-sm">
                No.
              </th>
              <th className="text-left py-3 px-4 uppercase font-semibold text-sm">
                Email
              </th>
              <th className="text-left py-3 px-4 uppercase font-semibold text-sm">
                Bought Products
              </th>
              <th className="text-left py-3 px-4 uppercase font-semibold text-sm">
                Bought At
              </th>
              <th className="text-left py-3 px-4 uppercase font-semibold text-sm">
                Total Price
              </th>
            </tr>
          </thead>
          <tbody className="text-gray-600">
            {users.map((user, index) => {
              const totalPrice = user.buyedProducts.reduce(
                (acc, product) => acc + product.price,
                0
              );

              return (
                <React.Fragment key={user._id}>
                  <tr>
                    <td className="py-4 px-6 border-b">{index + 1}.</td>
                    <td className="py-4 px-6 border-b">{user.email}</td>
                    <td className="py-4 px-6 border-b">
                      <ul>
                        {user.buyedProducts.map((product) => (
                          <li key={product._id}>
                            {product.title} (Price: {product.price})
                          </li>
                        ))}
                      </ul>
                    </td>
                    <td className="py-4 px-6 border-b">
                      {new Date(user.createdAt).toLocaleString()}
                    </td>
                    <td className="py-4 px-6 border-b">
                      Rs. {totalPrice.toFixed(2)}
                    </td>
                  </tr>
                  {index !== users.length - 1 && (
                    <tr className="bg-gray-100">
                      <td colSpan="5" className="py-2 px-4"></td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Dashboard;

// const Dashboard = () => {
//   const [users, setUsers] = useState([]);

//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const response = await axios.get(
//           "https://snk-music-store-backend.cyclic.app/user"
//         ); // Endpoint URL for fetching users
//         console.log(response.data[0].buyedProducts[0].title);
//         setUsers(response.data);
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     fetchUsers();
//   }, []);
//   return (
//     <div className="user-list-container">
//       <h2 className="user-list-heading">User List (Admin Panel)</h2>
//       <table className="user-table">
//         <thead>
//           <tr>
//             <th>Email</th>
//             <th>Bought Products</th>
//           </tr>
//         </thead>
//         <tbody>
//           {users.map((user, index) => (
//             <React.Fragment key={user._id}>
//               <tr>
//                 <td>{user.email}</td>
//                 <td>
//                   <ul className="product-list">
//                     {user.buyedProducts.map((product) => (
//                       <li key={product._id} className="product-item">
//                         {product.title} (Price: {product.price})
//                       </li>
//                     ))}
//                   </ul>
//                 </td>
//               </tr>
//               {index !== users.length - 1 && (
//                 <tr className="user-separator">
//                   <td colSpan="2"></td>
//                 </tr>
//               )}
//             </React.Fragment>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default Dashboard;
